import React from "react";
import FooterLink from "./FooterLink";

interface Link {
    name: string;
    url: string;
    external: boolean;
}

interface MobileFooterContentProps {
    links: Link[];
}

/**
 * Mobile footer content with centered layout
 */
const MobileFooterContent = ({ links }: MobileFooterContentProps) => {
    return (
        <div className="w-full flex flex-col items-center text-center gap-y-0">
            <div className="text-black text-xl font-bold mb-6 pb-[2px] w-[246px] text-center">Support</div>

            {links.map((link, index) => (
                <FooterLink
                    key={link.url}
                    name={link.name}
                    url={link.url}
                    external={link.external}
                    className={index === 2 || index === 5 ? "mb-4" : "mb-[14px]"}
                />
            ))}

            <p className="font-semibold italic text-center mb-[30px]">
                Monday - Friday 8am - 8pm ET
                <br />
                Saturday 11am - 3 pm ET
            </p>
        </div>
    );
};

export default MobileFooterContent;
